
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.212.027L21.115 0l13.693 14.008L21.128 28l13.047-.013L48 14.008 34.212.027z","fill":"#C6202E"}}),_c('path',{attrs:{"d":"M13.847 19.693c-3.11 0-5.63-2.549-5.63-5.693 0-3.144 2.521-5.693 5.63-5.693h14.202L19.821 0h-5.974C6.199 0 0 6.268 0 14s6.199 14 13.847 14h5.929l8.273-8.307H13.847z","fill":"#1A9C97"}})])
          )
        }
      }
    